class Storage {
    static setSession(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    }
    static getSession(key) {
        let value = window.sessionStorage.getItem(key);
        return value ? JSON.parse(value) : value;
    }
    static removeSession(key) {
        let value = this.getSession(key);
        window.sessionStorage.removeItem(key);
        return value;
    }
    
    static setLocal(key, value) {
        window.localStorage.setItem(key, JSON.stringify(value));
    }
    static getLocal(key) {
        let value = window.localStorage.getItem(key);
        return value ? JSON.parse(value) : value;
    }
    static removeLocal(key) {
        let value = this.getLocal(key);
        window.localStorage.removeItem(key);
        return value;
    }
}

export default Storage;